/* eslint-disable max-lines -- the rule was disabled before a comment became required */

/**
 * These lists are provided by Viola Schumann from Akaneo PROD
 * The plan is to load this list from backend, until that, for any update in the list contact Viola S.
 */

export const ATTRIBUTE_SORT_WEIGHT_SIZE = [
  // group1
  'size_onesize',
  'size_junior',
  'size_regular',
  'size_xxxxxs',
  'size_5xs',
  'size_xxxxs',
  'size_4xs',
  'size_xxxs',
  'size_3xs',
  'size_xxs_2xs',
  'size_xxs',
  'size_2xs',
  'size_xs',
  'size_xs0',
  'size_xs1',
  'size_xs2',
  'size_xs3',
  'size_xs4',
  'size_xs_s',
  'size_xs_s_extrasmall_small',
  'size_s',
  'size_s0',
  'size_s1',
  'size_s2',
  'size_s3',
  'size_s4',
  'size_s_m',
  'size_s_l_small_large',
  'size_m',
  'size_m0',
  'size_m1',
  'size_m2',
  'size_m3',
  'size_m4',
  'size_m_l',
  'size_l',
  'size_l0',
  'size_l1',
  'size_l2',
  'size_l3',
  'size_l4',
  'size_l_xl_large_extralarge',
  'size_xl',
  'size_xl0',
  'size_xl1',
  'size_xl2',
  'size_xl3',
  'size_xl4',
  'size_xl10',
  'size_xl_2xl',
  'size_xl_3xl',
  'size_xxl',
  'size_2xxl',
  'size_xxxl',
  'size_3xl',
  'size_xxxxl',
  'size_4xl',
  'size_xxxxxl',
  'size_5xl',
  'size_4xl',
  'size_xxxxxxl',
  'size_6xl',

  // group2
  'size_40x50',
  'size_40x60',
  'size_60x60',
  'size_60x75',
  'size_60x90',
  'size_70x140',
  'size_75x85',
  'size_75x100',
  'size_75x160',
  'size_75x185',
  'size_85x90',
  'size_80x120',
  'size_80x170',
  'size_80x180',
  'size_85x180',
  'size_85x190',
  'size_90x150',
  'size_90x160',
  'size_90x170',
  'size_90x180',
  'size_90x190',
  'size_90x200',
  'size_100x150',
  'size_100x200',
  'size_120x200',
  'size_135x200',
  'size_135x200_80x80',
  'size_140x200',
  'size_160x200',
  'size_180x200',
  'size_200x200',

  // group3
  'size_12_25kg',
  'size_16_30kg',

  // group4
  'size_35_38_wade_28_38cm_',
  'size_35_38_wade_36_42cm_',
  'size_39_42_wade_30_41cm_',
  'size_39_42_wade_39_46cm_',
  'size_43_46_wade_32_44cm_',
  'size_43_46_wade_42_48cm_',

  // group5
  'size_104_4jahre',
  'size_4_7jahre',
  'size_110_116_5_6jahre',
  'size_116_6jahre',
  'size_116_128_6_8jahre',
  'size_122_7jahre',
  'size_122_128_7_8jahre',
  'size_128_8jahre',
  'size_128_140_8_10jahre',
  'size_8_15jahre',
  'size_134_9jahre',
  'size_140_9_10jahre',
  'size_140_10jahre',
  'size_140_152_10_12jahre',
  'size_146_11jahre',
  'size_146_152_11_12jahre',
  'size_152_12jahre',
  'size_152_164_12_14jahre',
  'size_158_13jahre',
  'size_158_164_13_14jahre',
  'size_164_14jahre',
  'size_170_15jahre',
  'size_170_176_15_16jahre',
  'size_176_16jahre',

  // group6
  'size_0_7_1_3mm',
  'size_1_1_2_0mm',
  'size_5mm',

  // group7
  'size_1_0_45mm',
  'size_2_0_5mm',
  'size_3_0_6mm',
  'size_4_0_7mm',
  'size_5_0_8mm',
  'size_6_1_1mm',

  // group8
  'size_8cm',
  'size_12cm',
  'size_56cm',
  'size_70cm',
  'size_80cm',
  'size_90cm',
  'size_100cm',
  'size_110cm',
  'size_120cm',
  'size_130cm',
  'size_140cm',
  'size_150cm',

  // group9
  'size_1',
  'size_1a',
  'size_2',
  'size_2a',
  'size_3',
  'size_3a',
  'size_4',
  'size_4a',
  'size_5',
  'size_5a',
  'size_6',
  'size_6a',
  'size_7',
  'size_7a',
  'size_8',
  'size_8a',
  'size_9',
  'size_9a',
  'size_10',
  'size_11',
  'size_12',
  'size_13',
  'size_14',
  'size_15',
  'size_16',
  'size_17',
  'size_18',
  'size_19',
  'size_20',
  'size_21',
  'size_22',
  'size_23',
  'size_24',
  'size_25',
  'size_26',
  'size_27',
  'size_28',
  'size_29',
  'size_30',
  'size_31',
  'size_32',
  'size_33',
  'size_34',
  'size_35',
  'size_36',
  'size_36_38',
  'size_37',
  'size_38',
  'size_39',
  'size_40',
  'size_40_42',
  'size_41',
  'size_42',
  'size_43',
  'size_44',
  'size_44_46',
  'size_45',
  'size_46',
  'size_47',
  'size_48',
  'size_48_50',
  'size_49',
  'size_50',
  'size_50_56',
  'size_51',
  'size_52',
  'size_52_54',
  'size_53',
  'size_54',
  'size_55',
  'size_56_58',
  'size_57',
  'size_58',
  'size_59',
  'size_60',
  'size_61',
  'size_62',
  'size_62_68',
  'size_74',
  'size_74_80',
  'size_80',
  'size_86',
  'size_92',
  'size_98',
  'size_104',
  'size_110',
  'size_116',
  'size_122',
  'size_128',
  'size_134',
  'size_140',
]

export const ATTRIBUTE_SORT_WEIGHT_RESISTANCE = [
  'resist_extraleicht',
  'resist_leicht',
  'resist_mittel',
  'resist_schwer',
  'resist_extraschwer',
  'no_data',
]

export const ATTRIBUTE_SORT_WEIGHT_CBD_CONTENT = [
  'cbd_content_2_75percent',
  'cbd_content_4percent',
  'cbd_content_5percent',
  'cbd_content_6percent',
  'cbd_content_8percent',
  '10_percent',
  'cbd_content_15percent',
  'cbd_content_20percent',
  'cbd_content_25percent',
  'cbd_content_150mg',
  'cbd_content_300mg',
]

export const ATTRIBUTE_SORT_WEIGHT_NOMINAL_WEIGHT = [
  'weight_0_5kg',
  'weight_1kg',
  'weight_1_25kg',
  'weight_1_5kg',
  'weight_2kg',
  'weight_2x1_kg',
  'weight_2_5kg',
  'weight_3kg',
  'weight_4_kg',
  'weight_2x2_kg',
  'weight_5kg',
  'weight_2x2_5kg',
  'weight_6_kg',
  'weight_2x3_kg',
  'weight_6_5_kg',
  'weight_7_kg',
  'weight_7_5kg',
  'weight_8_kg',
  'weight_2x4_kg',
  'weight_9_kg',
  'weight_9_5_kg',
  'weight_10kg',
  'weight_2x5_kg',
  'weight_12_kg',
  'weight_2x6_kg',
  'weight_12_5kg',
  'weight_2x7_kg',
  'weight_15kg',
  'weight_2x8_kg',
  'weight_16_kg',
  'weight_17_5_kg',
  'weight_18_kg',
  'weight_2x9_kg',
  'weight_20kg',
  'weight_2x10_kg',
  'weight_22_5_kg',
  'weight_24_kg',
  'weight_25kg',
  'weight_27_5_kg',
  'weight_28_kg',
  'weight_30_kg',
]

export const ATTRIBUTE_SORT_WEIGHT_PATCH_SIZE = [
  // 0-1cm
  '3_mm_x_75_mm',
  '4_0_mm_x_38_mm',
  '6_mm_x_38_mm',
  '6_mm_x_75_mm',
  '6_4_mm_x_76_mm',

  // 1cm
  '1_cm_x_5_m',
  '1_cm_x_6_cm',
  '12_mm_x_100_mm',
  '12_mm_x_102_mm',
  '1_25_cm_x_2_6',
  '1_25_cm_x_5_m',
  '1_25_cm_x_9_1_m',
  '1_25_cm_x_9_2_m',
  '1_25_cm_x_10_m',
  '13_0_mm_x_102_mm',
  '1_5_cm_x_4_cm',
  '1_5_cm_x_15_m',
  '1_7_cm_x_4_cm',
  '1_7_x_6_',
  '1_9_cm_x_4_cm',
  '1_90_cm_x_0_07_m',
  '1_9_cm_x_7_2_cm',

  // 2cm
  '2_cm_x_3_cm',
  '2_cm_x_4_cm',
  '2_cm_x_6_cm',
  '2_cm_x_7_cm',
  '2_cm_x_12_cm',
  '2_cm_x_18_cm',
  '2_cm_x_20_m',
  '2_cm_x_30_cm',
  '2_cm_x_30_4_cm',
  '2_cm_x_45_cm',
  '2_cm_x_50_cm',
  '2_cm_x_5_m',
  '2_cm_x_7_15_m_x_10_cm',
  '2_cm_x_10_m',
  '2_5_cm_x_2_5_m_x_',
  '2_5_cm_x_2_5_cm',
  '2_5_cm_x_2_6_cm',
  '2_5_cm_x_4_5_cm',
  '2_5_cm_x_4_5',
  '2_5_cm_x_7_2_cm',
  '2_5_cm_x_30_cm',
  '2_5_cm_x_2_6_m',
  '2_5_cm_x_4_m',
  '2_5_cm_x_4_5_m',
  '2_5_cm_x_4_6_m',
  '2_5_cm_x_5_m',
  '2_50_cm_x_5_m',
  '2_5_cm_x_9_1_m',
  '2_5_cm_x_9_2_m',
  '2_5_cm_x_10_m',
  '2_5_cm_x_15_m',
  '2_54_cm_x_7_mm',
  '2_7_cm_x_34_cm',

  // 3cm
  '3_cm_x_4_5_m',
  '3_cm_x_5_cm',
  '3_cm_x_6_cm',
  '3_0_cm_x_7_2_cm',
  '3_cm_x_44_cm',
  '3_5_cm_x_1_m',
  '3_5_cm_x_10_m',
  '3_75_cm_x_7_5_cm',
  '3_75_cm_x_12_5_cm',
  '3_75_cm_x_22_5_cm',
  '3_75_cm_x_7_m',
  '3_75_cm_x_10_m',
  '3_8_cm_x_3_8_cm',
  '3_8_cm_x_10_m',

  // 4cm
  '4_cm_x_1_cm',
  '4_cm_x_1_7_cm',
  '4_cm_x_1_9_cm',
  '0_04_m_x_1_90_cm',
  '4_cm_x_10_cm',
  '4_cm_x_2_cm',
  '4_cm_x_5_cm',
  '4_cm_x_6_cm',
  '4_cm_x_7_cm',
  '4_cm_x_7cm',
  '4_cm_x_8_cm',
  '4_cm_x_20_cm',
  '4_cm_x_30_cm',
  '4_cm_x_1_m',
  '4_cm_x_150_cm',
  '4_cm_x_4_m',
  '4_cm_x_5_m',
  '4_cm_x_10_m',
  '4_cm_x_20_m',
  '4_4_cm_x_4_4_cm',
  '4_5_cm_x_4_5_cm',
  '4_5_cm_x_5_5_cm',
  '4_5_cm_x_6_cm',
  '4_5_cm_x_10_cm',
  '4_5_cm_x_30_cm',

  // 5cm
  '0_05_m_x_4_40_cm',
  '5_cm_x_5',
  '5_cm_x_5_cm',
  '5_cm_x_5_cm_',
  '5_cm_x_5_cm_8',
  '5_cm_x_6_cm',
  '5_cm_x_7',
  '5_cm_x_7_2_cm',
  '5_cm_x_7_5_cm',
  '5_cm_x_7_cm',
  '5_cm_x_7cm',
  '5_cm_x_7m',
  '5_cm_x_8_cm',
  '5_cm_x_9_cm',
  '5_cm_x_10_cm',
  '5_cm_x_12_5_cm',
  '5_cm_x_15_cm',
  '5_cm_x_25_cm',
  '5_cm_x_1_m',
  '5_cm_x_2_7_m',
  '5_cm_x_5_m',
  '5_cm_x_9_1_m',
  '5_cm_x_9_2_m',
  '5_cm_x_10_m',
  '5_3_cm_x_7_0_cm',
  '5_3_cm_x_7_cm',
  '5_5_cm_x_1_cm',
  '5_5_cm_x_5_5_cm',
  '5_5_cm_x_7_5_cm',
  '5_5_cm_x_12_cm',
  '5_6_cm_x_6_cm',
  '5_6_cm_x_7_0_cm',
  '5_6_cm_x_7_cm',
  '5_6_cm_x_7_2_cm',
  '5_7_cm_x_8_cm',
  '5_8_cm_x_7_cm',

  // 6cm
  '6_cm_x_5_mm',
  '6_cm_x_38_mm',
  '6_cm_x_5_cm',
  '6_cm_x_6_cm',
  '6_cm_x_7_cm',
  '6_cm_x_7_6_cm',
  '6_cm_x_76_mm',
  '6_cm_x_8_cm',
  '6_cm_x_10_cm',
  '6_cm_x_15_cm',
  '6_cm_x_1_m',
  '6_cm_x_2_m',
  '6_cm_x_3_m',
  '6_cm_x_3_5_m',
  '6_cm_x_4_m',
  '6_cm_x_5_m',
  '6_cm_x_7_m',
  '6_cm_x_10_m',
  '6_cm_x_15_m',
  '6_cm_x_20_m',
  '6_cm_x_21_m',
  '6_4_cm_x_7_6_cm',
  '6_4_cm_x_102_mm',
  '6_5_cm_x_5_cm',
  '6_5_cm_x_9_5_cm',
  '6_5_cm_x_10_cm',
  '6_5_cm_x_22_cm',
  '6_5_cm_x_10_m',
  '6_8_cm_x_4_2_cm',

  // 7cm
  '0_07_m_x_1_90_cm',
  '0_07_m_x_2_80_cm',
  '7_cm_x_4_2_cm',
  '7_cm_x_4_8_cm',
  '7_cm_x_5_3_cm',
  '7_cm_x_5_cm',
  '7_cm_x_7_5_cm',
  '7_cm_x_8_5_cm',
  '7_cm_x_8_cm',
  '7_cm_x_9_cm',
  '7_x_8_5_cm',
  '7_cm_x_10_cm',
  '7_cm_x_27_5_m',
  '7_2_cm_x_1_9_cm',
  '7_2_cm_x_2_5_cm',
  '7_2_cm_x_5_cm',
  '7_2_cm_x_5_cm_',
  '7_4_cm_x_4_5_cm',
  '7_5_cm_x_4_6_cm',
  '7_5_cm_x_5_cm',
  'M7_5_cm_x_7_5_cm',
  '75_mm_x_80_mm',
  '7_5cm_x_10_cm',
  '7_5_cm_x_10_cm',
  '7_5_cm_x_12_5_cm',
  '7_5_cm_x_20_cm',
  '7_5_cm_x_7_5',
  '7_5_cm_x_7_5_cm',
  '7_5_cm_x_8_5_cm',
  '7_5_cm_x_1_m',
  '7_5_cm_x_2_7_m',
  '7_5_cm_x_4_5_m',
  '7_5_cm_x_4_6_m',
  '7_5_cm_x_5_m',
  '7_5_cm_x_10_m',
  '7_6_cm_x_0_3_cm',
  '7_6_cm_x_7_6_cm',
  '7_6_cm_x_9_5_cm',
  '7_6_cm_x_20_3_cm',
  '7_8_cm_x_10_cm',

  // 8cm
  '8_cm_x_5_mm',
  '8_cm_x_5_8_cm',
  '8_cm_x_5_cm',
  '8_cm_x_6_cm',
  '8_cm_x_8_cm',
  '8_cm_x_10_cm',
  '8_cm_x_13_cm',
  '8_cm_x_15_cm',
  '8_cm_x_20_cm',
  '8_cm_x_1_m',
  '8_cm_x_2_5_m',
  '8_cm_x_2_m',
  '8_cm_x_3_m',
  '8_cm_x_3_5_m',
  '8_cm_x_4_m',
  '8_cm_x_5_m',
  '8_cm_x_7m',
  '8_cm_x_7_m',
  '8_cm_x_10_m',
  '8_cm_x_15_m',
  '8_cm_x_20_m',
  '8_cm_x_21_m',
  '8_3_cm_x_6_cm',
  '8_5_cm_x_4_cm',
  '8_5_cm_x_8_5_cm',
  '8_5_cm_x_13_cm',
  '8_8_cm_x_8_8_cm',

  // 9cm
  '9_cm_x_5_cm',
  '9_cm_x_6_cm',
  '9_cm_x_7_cm',
  '9_cm_x_10_cm',
  '9_cm_x_11_cm',
  '9_cm_x_15_cm',
  '9_cm_x_20_cm',
  '9_cm_x_21_cm',
  '9_cm_x_25_cm',
  '9_5_cm_x_8_5_cm',

  // 10cm

  '10_cm_x_3_mm',
  '10_cm_x_5_mm',
  '10_cm_x_3_75_cm',
  '10_cm_x_4_cm',
  '10_cm_x_5_cm',
  '10_cm_x_6_cm',
  '10_cm_x_7_cm',
  '10_cm_x_7_8_cm',
  '10_cm_x_8_cm',
  '10_cm_x_9_cm',
  '10_cm_x_10',
  '10_cm_x_10_',
  '1_10_cm_x_10_cm',
  '10_cm_x_10_cm',
  '10_cm_x_10_cm_8',
  '10_cm_x_10_12',
  '10_cm_x_11_cm',
  '10_cm_x_11_5_cm',
  '10_cm_x_12_cm',
  '10_cm_x_12_5_cm',
  '10_cm_x_14_cm',
  '10_cm_x_15',
  '10_cm_x_15_cm',
  '10_cm_x_16_cm',
  '10_cm_x_18_cm',
  '_10_cm_x_20_cm',
  '10_cm_20_cm',
  '10_cm_x_20_cm',
  '10_cm_x_20_cm_8c',
  '10_cm_x_20_cm_12',
  '10_cm_x_20_8',
  '10_cm_x_22_5_cm',
  '10_cm_x_25_cm',
  '10_cm_x_30_cm',
  '10_cm_x_35_cm',
  '10_cm_x_38_cm',
  '10_cm_x_40_cm',
  '10_cm_x_1_m',
  '10_cm_x_2_m',
  '10_cm_x_2_5_m',
  '10_cm_x_2_5_m_x_0_3_cm',
  '10_cm_x_2_5_m_x_0_4_cm',
  '10_cm_x_2_7_m',
  '10_cm_x_2_75_m',
  '10_cm_x_3_m',
  '10_cm_x_4_m',
  '10_cm_x_4_m_',
  '10_cm_x_5_m',
  '10_cm_x_6_5_m',
  '10_cm_x_7m',
  '10_cm_x_700cm',
  '10_cm_x_7_m',
  '10_cm_x_9_1_m',
  '10_cm_x_10_m',
  '10_cm_x_14_m',
  '10_cm_x_15_m',
  '10_cm_x_20_m',
  '10_cm_x_21_m',
  '10_cm_x_40_m',
  '10_2_cm_x_6_4_cm',
  '10_3_cm_x_10_3_cm',
  '10_5_cm_x_10_5_cm',
  '10_5_cm_x_19_cm',
  '10_75_cm_x_1_m',
  '10_75_cm_x_10_m',

  // 11cm
  '11_cm_x_11_cm',
  '11_cm_x_35_cm',
  '11_4_cm_x_3_7_m',

  // 12cm
  '12_cm_x_5_mm',
  '12_cm_x_38_mm',
  '0_12_m_x_1_90_cm',
  '12_cm_x_2_cm',
  '12_cm_x_2_5_cm',
  '12_cm_x_2_5_m_x_0_4_cm',
  '12_cm_x_5_cm',
  '12_cm_x_10_cm',
  '12_cm_x_10_2_cm',
  '12_cm_x_12_cm',
  '12_cm_x_13_cm',
  '12_cm_x_15_cm',
  '12_cm_x_18_cm',
  '12_cm_x_20_cm',
  '12_cm_x_28_cm',
  '12_cm_x_2_m',
  '12_cm_x_2_5_m',
  '12_cm_x_4_m',
  '12_cm_x_5_m',
  '12_cm_x_7_m',
  '12_cm_x_10_m',
  '12_cm_x_15_m',
  '12_cm_x_20_m',
  '12_cm_x_21_m',
  '12_5cmx12_5cm',
  '12_5_cm_x_12_5_cm',
  '12_5_cm_x_22_5_cm',
  '12_7_cm_x_22_9_cm',
  '12_9_cm_x_12_9_cm',

  // 13cm
  '13_cm_x_9_5_cm',
  '13_cm_x_14_cm',
  '13_cm_x_16_cm',
  '13_cm_x_19_cm',
  '13_cm_x_22_cm',
  '13_cm_x_28_cm',
  '13_5_cm_x_18_cm',
  '13_5_cm_x_25_cm',

  // 14cm
  '14_cm_x_14_cm',
  '14_cm_x_16_cm',
  '14_cm_x_19_5_cm',
  '14_2_cm_x_15_8_cm',
  '14_3_cm_x_14_3_cm',
  '14_3_cm_x_15_6_cm',

  // 15cm
  '15_cm_x_7_8_cm',
  '15_cm_x_8_cm',
  '15_cm_x_9_cm',
  '15_cm_x_10_cm',
  '15_cm_x_15_cm',
  '15_cm_x_15_cm_x_1_cm',
  '15_cm_x_17_cm',
  '15_cm_x_19_cm',
  '15_cm_x_20_cm',
  '15_cm_x_25_cm',
  '15_cm_x_30_cm',
  '15_cm_x_2_m',
  '15_cm_x_2_7_m',
  '15_cm_x_3_m',
  '15_cm_x_4_m',
  '15_cm_x_5_m',
  '15_cm_x_10_m',
  '15_cm_x_20_m',
  '15_4_cm_x_15_4_cm',

  // 16cm
  '16_cm_x_16_cm',
  '16_cm_x_20_3_cm',
  '16_cm_x_24_cm',
  '16_cm_x_26_cm',
  '16_8_cm_x_17_1cm',

  // 17cm
  '17_cm_x_17cm',
  '17_cm_x_18_cm',
  '17_1_cm_x_17_9_cm',
  '17_5_cm_x_17_5_cm',

  // 18cm
  '18_cm_x_18_cm',
  '0_18_m_x_1_90_cm',
  '18_cm_x_2_cm',
  '18_5_cm_x_18_5_cm',

  // 19cm
  '19_cm_x_38_mm',
  '19_cm_x_56_mm',
  '19_cm_x_7_cm',
  '19_cm_x_72_mm',
  '19_cm_x_20_cm',
  '19_cm_x_21_cm',
  '19_cm_x_38_cm',
  '19_8_cm_x_10_cm',

  // 20cm
  '20_cm_x_5_mm',
  '20_cm_x_9_cm',
  '20_cm_x_10_cm',
  '20_cm_x_20_cm',
  '20_cm_x_25_cm',
  '20_cm_x_30_cm',
  '20_cm_x_40_cm',
  '20_cm_x_40cm',
  '20_cm_x_50_cm',
  '20_cm_x_1_m',
  '20_cm_x_2_m',
  '20_cm_x_5_m',
  '20_cm_x_10_m',
  '20_cm_x_20_m',
  '20_cm_x_22_m',

  // 21cm
  '21_cm_x_21cm',
  '21_cm_x_38_cm',
  '21_3_cm_x_24_5_cm',
  '21_6_cm_x_22_cm',

  // 22cm
  '22_cm_x_72_mm',
  '22_cm_x_9_5_cm',
  '22_cm_x_12_cm',
  '22_cm_x_22_cm',
  '22_cm_x_23_cm',
  '22_5_cm_x_22_5_cm',
  '22_5_cm_x_32_cm',

  // 23cm
  '23_cm_x_23_cm',
  '23_cm_x_23_2_cm',

  // 24cm
  '24_cm_x_21_5_cm',
  '24_8_cm_x_10_cm',

  // 25cm
  '25_mm_x_72_mm',
  '25_cm_x_9_cm',
  '25_cm_x_10_cm',
  '25_cm_x_12_7_cm',
  '25_cm_x_25_cm',
  '25_cm_x_25_2_cm',
  '25_cm_x_30_cm',

  // 26cm
  '26_cm_x_57_mm',
  '26_0_cm_x_102_mm',

  // 27cm
  '27_cm_x_28_cm',
  '27_5_cm_x_7_5_cm',

  // 28cm
  '28_5_cm_x_8_5_cm',

  // 30cm
  '30_mm_x_72_mm',
  '30_cm_x_9_cm',
  '30_cm_x_5_m',
  '30_cm_x_10_m',

  // 38cm
  '38_cm_x_38_mm',
  '38_cm_x_63_mm',
  '38_cm_x_72_mm',

  // 40cm
  '40_cm_x_60_cm',
  '40_cm_x_60cm',

  // 44cm
  '44_5_cm_x_51_mm',

  // 45cm
  '45_cm_x_65_mm',
  '45_cm_x_25_cm',
  '45_cm_x_55_cm',

  // 47cm
  '47_5_cm_x_7_5_cm',

  // 48cm
  '48_cm_x_28_cm',

  // 49cm
  '49_cm_x_59_cm',

  // 50cm
  '50_cm_x_6_cm',
  '0_5_m_x_6_cm',
  '50_cm_x_27_cm',
  '50_cm_x_50_m',

  // 56cm
  '56_cm_x_72_mm',
  '59_cm_x_50_m',

  // 60cm
  '60_cm_x_30_mm',
  '60_cm_x_80_mm',
  '60_cm_x_88_mm',
  '60_cm_x_10_cm',
  '60_cm_x_80_cm',

  // 67cm
  '67_5_cm_x_7_5_cm',

  // 68cm
  '68_cm_x_43_mm',

  // 70cm
  '70_cm_x_85_mm',

  // 75cm
  '75_cm_x_90_cm_2',

  // 76cm
  '76_cm_x_54_mm',

  // 80cm
  '80_cm_x_100_mm',
  '80_cm_x_1_m',
  '80_cm_x_120_cm',
  '80_cm_x_2_m',
  '80_cm_x_5_m',
  '80_cm_x_10_m',
  '80_cm_x_10_m_cc',
  '80_cm_x_20_m',

  // 85cm
  '85_cm_x_5_cm',

  // 96cm
  '96_cm_x_67_mm',

  // 1m+
  '1_m_x_4_cm',
  '1_m_x_6_cm',
  '1_m_x_8_cm',
  '100_cm_x_120_mm',
  '125_cm_x_5_cm',
  '127_5_cm_x_7_5_cm',
  '128_cm_x_183_mm',
  '2_m_x_6_cm',
  '2_m_x_10_cm',
  '2_5_m_x_6_cm',
  '2_5_m_x_8_cm',
  '2_5_m_x_10_cm',
  '3_m_x_6_cm',
  '3_m_x_10_cm',
  '3_m_x_15_cm',
  '3_m_x_25_cm',
  '4_m_x_4_cm',
  '4_m_x_6_cm',
  '4_m_x_8_cm',
  '4_m_x_10_cm',
  '4_m_x_12_cm',
  '5_m_x_1cm',
  '5_m_x_1_25_cm',
  '5_m_x_2_cm',
  '5_m_x_2_5_cm',
  '5_m_x_2_50_cm',
  '5_m_x_4_cm',
  '5_m_x_5_cm',
  '5_m_x_6_cm',
  '5_m_x_8_cm',
  '5_m_x_10_cm',
  '5_m_x_12_cm',
  '5_m_x_15_cm',
  '5_m_x_20_cm',
  '5_m_x_30_cm',
  '5_m_x_56_cm',
  '10_m_x_2_cm',
  '10_m_x_2_5_cm',
  '10_m_x_3_8_cm',
  '10_m_x_5_cm',
  '10_m_x_10_cm',
  '10_m_x_12_cm',
  '10_m_x_20_cm',
  '10_m_x_28_cm',
  '10_m_x_1_m',
  '10_m_x_7_m',
  '11_m_x_10_cm',
  '20_m_x_4_cm',
  '20_m_x_6_cm',
  '20_m_x_8_cm',

  // nodata
  'no_data',
  'not_relevant',
]

export const ATTRIBUTE_SORT_WEIGHT_CONSISTENCY = [
  'nature_elastisch',
  'nature_starr',
  'no_data',
]

export const ATTRIBUTE_SORT_WEIGHT_ANIMAL_SIZE = [
  'animalsize_4kg',
  'animalsize_s4kg',
  'animalsize_l4kg',
  'animalsize_10kg',
  'animalsize_s10kg',
  'animalsize_10_25kg',
  'animalsize_25kg',
  'animalsize_l25kg',
  'no_data',
]

export const ATTRIBUTE_SORT_WEIGHT_PACKAGING_VARIANT = [
  'variant_glasflasche',
  'variant_spraydose',
  'variant_flasche',
  'variant_dosierspender',
  'variant_refill',
  'variant_spraydoseinklmaske',
  'variant_spraydoseinklinhalierbecher',
  'variant_spenderflasche',
  'variant_dose',
  'variant_kanister',
  'variant_hyclick',
  'variant_ohnezubehoer',
  'variant_inklinhalator',
  'variant_inklapplikationshilfe',
  'variant_dosierflasche',
  'variant_rundflasche',
  'variant_spruehflasche',
  'variant_inkldosierspender',
  'variant_tube',
  'variant_inkllaeusekamm',
  'variant_blister',
  'variant_aktionsgroesse',
  'variant_pumpflasche',
  'variant_vierkantflasche',
  'variant_spenderdose',
  'variant_einzelnverpackt',
  'variant_1l',
  'variant_2l',
  'variant_plastikflasche',
  'variant_ecotube',
  'variant_ecoflasche',
  'variant_set',
  'no_data',
]

export const ATTRIBUTE_SORT_WEIGHT_ADDITION = []

export const ATTRIBUTE_SORT_WEIGHT_CANNULA_LENGTH = []

export const ATTRIBUTE_SORT_WEIGHT_TUBE_LENGTH = []
